import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import Notification from '..//Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import InputText from '../Common/InputText';
import './BulkReassignDrawer.scss';

export class BulkReassignDrawer extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            users: [],
            searchTerm: "",
            selectedUser: null,
            hasSearched: false,
            isSearchingUsers: false,
            isLoading: false,
            isFormValid: true
        };
    }

    searchUsers = async () => {
        try {
            this.setState({ isSearchingUsers: true });
            const result = await this.props.projectMgrDashboardActions.projectFilesBulkReassignFilters(this.state.searchTerm);
            const payload = result.payload;
            if (result.type === types.SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_SUCCESS) {
                this.setState({ users: result.payload.users });
            } else if (result.type === types.SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isSearchingUsers: false, hasSearched: true });
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        if(this.state.searchTerm && this.state.searchTerm.length >= 1){
            this.searchUsers();
        }
        return false;
    }

    selectUser = (user) => {
        this.setState({ selectedUser: user });
    }

    updateTerm = (e) => {
        const term = e.target.value;
        this.setState({ searchTerm: term });
    }

    saveClick = () => {
        if(!this.state.selectedUser){
            Notification("error", "", "Please select a user")
        } else {
            this.props.onComplete(this.state.selectedUser);
        }
    }

    render() {
        const resultText = (this.state.users.length == 1) ? "result" : "results";

        return (
            <Drawer isWide={false} title="Reassign" onSaveClick={this.saveClick} onCancelClick={this.props.onCancel}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                <div className="bulk-reassign-drawer">
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                            <InputText
                                name="userSearch"
                                value={this.state.searchTerm}
                                label="Search"
                                type="text"
                                onChange={this.updateTerm} />
                                <div className="sub-heading">Type 3 characters and press enter to search</div>
                        </form>
                        <LoadingIndicator isLoading={this.state.isSearchingUsers}>
                            {this.state.users && this.state.users.length > 0 &&
                                <Fragment>
                                    <div className="user-results">{this.state.users.length} {resultText} found</div>
                                    <ul className="list-group">
                                        { this.state.users.map(user => 
                                            <li className={user === this.state.selectedUser ? "list-group-item active" : "list-group-item"} 
                                                key={user.id} 
                                                onClick={() => this.selectUser(user)}>{user.firstName} {user.lastName} ({user.userName})
                                            </li>
                                        )
                                        }
                                    </ul>                              
                                </Fragment>
                            }     
                            { this.state.users && this.state.users.length === 0 && this.state.hasSearched &&
                                <div className="user-results">No results</div>
                            }           
                        </LoadingIndicator>
                    </div>
                </LoadingIndicator>
            </Drawer>
        );
    }
}

BulkReassignDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    projectMgrDashboardActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default BulkReassignDrawer;

